export default __webpack_public_path__ + "static/icon-19-1-a4d620a69ae8edf3b7941a42495da740.png";